import { getApiBaseUrl } from './base-url';
import {
  buildApiClientHelpers,
  fetcher,
  buildConfig,
  type RequestInitWithJsonContent,
} from './build-api-client';

let token: string | undefined;
let trackingId: string | undefined;

export const apiClient = buildApiClientHelpers(baseClient);

export type ApiClient = ReturnType<typeof buildApiClientHelpers>;

function baseClient<T>(
  endpoint: string,
  customConfig: RequestInitWithJsonContent = {},
): Promise<T> {
  const config = buildConfig(customConfig, token, trackingId);
  const baseUrl = getApiBaseUrl();
  return fetcher<T>(baseUrl, endpoint, config);
}

export function setJwtToken(jwtToken: string) {
  token = jwtToken;
}

export function getJwtToken() {
  return token;
}

export function clearJwtToken() {
  token = undefined;
}

export function setTrackingId(value: string) {
  trackingId = value;
}
